import { useMutation } from '@apollo/client/react'
import { Grid, Button } from '@design-systems/canvas-ui'
import Icon, {
  MenuAppsIcon,
  ArrowUpRightIcon,
} from '@design-systems/react-icons'
import {
  FEDERATED_ADD_RECENTLY_SEARCHED,
  RECENT_SEARCH_REFETCH_QUERIES,
} from 'graphql/queries/globalSearch/recentSearchesQueries'
import { useNavigate } from 'react-router-dom'

type ViewAllResultsProps = {
  totalResults: string
  searchTerm: string
  setShowQuickSearchDropdown: (focus: boolean) => void
}

export const ViewAllResults = ({
  totalResults,
  searchTerm,
  setShowQuickSearchDropdown,
}: ViewAllResultsProps) => {
  const navigate = useNavigate()
  const [addRecentlySearched] = useMutation(FEDERATED_ADD_RECENTLY_SEARCHED, {
    refetchQueries: RECENT_SEARCH_REFETCH_QUERIES,
    awaitRefetchQueries: true,
  })

  return (
    <Grid.Container
      align="center"
      className="hc8-pb-2x"
      justify="space-between"
    >
      <Grid.Item>
        <Icon svg={MenuAppsIcon} className="hc8-clr-brand" size="lg" />
      </Grid.Item>
      <Grid.Item size={{ xs: true }}>
        <em>
          {totalResults !== '0' ? 'View all results' : 'No results found'}
        </em>
      </Grid.Item>
      <Grid.Item>
        {totalResults !== '0' ? (
          <Button
            onClick={() => {
              addRecentlySearched({ variables: { searchTerm } })
              navigate(`/searchResults/${searchTerm}`)
              setShowQuickSearchDropdown(false)
            }}
            align="right"
            variant="secondary"
            size="sm"
          >
            {totalResults}
            <Icon svg={ArrowUpRightIcon} className="hc8-clr-brand" />
          </Button>
        ) : null}
      </Grid.Item>
    </Grid.Container>
  )
}
